<template>
    <div class="login">
        <div class="login-logo">
            <span v-if="ifLps3">
                <img
                    src="http://static.lpswish.com/ew/2311/22/19c9fbf4ce52441e952b2d6db86fb8cd.png"
                />
            </span>
            <span v-else-if="ifLps2">
                <img src="static/images/logo/lpscn.png" />
            </span>
            <span v-else>
                <span v-if="ifLps">
                    <img src="static/images/logo/ykyqs.png" />
                </span>
                <span v-else>
                    <img src="static/images/logo/qsykw.png" />
                </span>
            </span>
        </div>
        <el-form
            :model="loginForm"
            :rules="fieldRules"
            ref="loginForm"
            label-position="left"
            label-width="0px"
            class="login-container"
        >
            <h2 class="title" style="padding-left:22px;">系统登录</h2>
            <el-form-item prop="userName">
                <el-input
                    type="text"
                    @keyup.enter.native="login('loginForm')"
                    v-model="loginForm.userName"
                    auto-complete="off"
                    placeholder="账号"
                ></el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input
                    type="password"
                    @keyup.enter.native="login('loginForm')"
                    v-model="loginForm.password"
                    auto-complete="off"
                    placeholder="密码"
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-col :span="12">
                    <el-form-item prop="patchca">
                        <el-input
                            type="test"
                            v-model="loginForm.patchca"
                            auto-complete="off"
                            placeholder="验证码, 单击图片刷新"
                            style="width: 100%;"
                            @keyup.enter.native="login('loginForm')"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col class="line" :span="1">&nbsp;</el-col>
                <el-col :span="11">
                    <el-form-item>
                        <img
                            style="width: 100%;"
                            class="pointer"
                            :src="loginForm.src"
                            @click="refreshPatchca"
                        />
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-form-item class="operation" style="line-height: 15px !important;margin-bottom: 10px;height: 10px;">
                <el-col :span="12" style="text-align: left;">
                    <el-checkbox v-model="rememberMe" checked class="remember"
                        >记住密码</el-checkbox
                    >
                </el-col>
                <!-- <el-col :span="12" style="text-align: right;color: #409EFF"
                    ><span style="cursor: pointer" @click="handleRegister"
                        >注册账号</span>
                </el-col>-->
            </el-form-item>

                <el-button
                    type="primary"
                    style="width:100%;"
                    @click.native.prevent="login('loginForm')"
                    :loading="loading"
                    >登 录
                </el-button>

        </el-form>
        <div class="login-footer">
            <span v-if="ifLps3">
                <span>© 2025 liuxueart.com 版权所有</span>
                <span
                    >备案号：<a href="http://beian.miit.gov.cn" target="_blank"
                        >浙ICP备2023035788号-1</a
                    ></span
                >
                <!-- <span><img src="http://static.lpswish.com/intro/beian.png" width="15" height="15">&nbsp;浙公网安备：<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014445" target="_blank">33011002014445号</a></span>-->
            </span>
            <span v-else-if="ifLps2">
                <span>© 2025 lpswish.cn 版权所有</span>
                <span
                    >备案号：<a href="http://beian.miit.gov.cn" target="_blank"
                        >浙ICP备2022025845号-1</a
                    ></span
                >
                <!-- <span><img src="http://static.lpswish.com/intro/beian.png" width="15" height="15">&nbsp;浙公网安备：<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014445" target="_blank">33011002014445号</a></span>-->
            </span>
            <span v-else>
                <span v-if="ifLps">
                    <span>© 2019-2026 lpswish.com 版权所有</span>
                    <span
                        >备案号：<a
                            href="http://beian.miit.gov.cn"
                            target="_blank"
                            >浙ICP备20004145号-1</a
                        ></span
                    >
                    <span
                        ><img
                            src="http://static.lpswish.com/intro/beian.png"
                            width="15"
                            height="15"
                        />&nbsp;浙公网安备：<a
                            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014445"
                            target="_blank"
                            >33011002014445号</a
                        ></span
                    >
                    <span>
                        <a
                            href="https://xyt.xcc.cn/getpcInfo?sn=1772217496066023424&language=CN&certType=8&url=*.lpswish.com"
                            target="_blank"
                            style="position: relative;display: inline-block;height: 38px;"
                        >
                            <div
                                style="width:100%;height:100%;position: absolute;top: 0;left: 0;"
                            ></div>
                            <embed
                                src="https://program.xinchacha.com/web/1772217496066023424=*.lpswish.com.svg"
                                width="103"
                                height="38"
                                type="image/svg+xml"
                                pluginspage="//www.adobe.com/svg/viewer/install/"
                            />
                        </a>
                    </span>
                </span>
                <span v-else>
                    <span>© 2019-2026 easywish.cn 版权所有</span>
                    <span
                        >备案号：<a
                            href="http://beian.miit.gov.cn"
                            target="_blank"
                            >浙ICP备20004145号-3</a
                        ></span
                    >
                    <span
                        ><img
                            src="http://static.lpswish.com/intro/beian.png"
                            width="15"
                            height="15"
                        />&nbsp;浙公网安备：<a
                            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014305"
                            target="_blank"
                            >33011002014305号</a
                        ></span
                    >
                    <!-- <span>
                       <a href="https://xyt.xcc.cn/getpcInfo?sn=1549280390525435904&language=CN&certType=8&url=*.easywish.cn" target="_blank" style="position: relative;">
                                <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div><embed src="https://program.xinchacha.com/web/1549280390525435904=*.easywish.cn.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/></a>
                    </span> -->
                    <span>
                        <a
                            href="https://xyt.xcc.cn/getpcInfo?sn=1516666377757220864&language=CN&certType=8&url=*.lpswish.com"
                            target="_blank"
                            style="position: relative;display: inline-block;height: 38px;"
                        >
                            <div
                                style="width:100%;height:100%;position: absolute;top: 0;left: 0;"
                            ></div>
                            <embed
                                src="https://program.xinchacha.com/web/1516666377757220864=*.lpswish.com.svg"
                                width="103"
                                height="38"
                                type="image/svg+xml"
                                pluginspage="//www.adobe.com/svg/viewer/install/"
                        /></a>
                    </span>
                </span>
            </span>
        </div>
        <vue-particles
            color="#fff"
            :particleOpacity="0.7"
            :particlesNumber="100"
            shapeType="circle"
            :particleSize="4"
            linesColor="#fff"
            :linesWidth="1"
            :lineLinked="true"
            :lineOpacity="0.4"
            :linesDistance="150"
            :moveSpeed="3"
            :hoverEffect="true"
            hoverMode="grab"
            :clickEffect="true"
            clickMode="push"
            class="particles"
        >
        </vue-particles>
    </div>
</template>

<script>
// import api from '@/http/api'
// import store from '@/store'

export default {
    name: 'Login',
    data() {
        var validateName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入帐号'))
            } else {
                callback()
            }
        }
        var validatePwd = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'))
            } else {
                callback()
            }
        }
        var validateCode = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入验证码'))
            } else {
                callback()
            }
        }
        return {
            loading: false,
            loginForm: {
                userName: '',
                password: '',
                patchca: '',
                src: ''
            },
            ifLps: false,
            ifLps2: false,
            ifLps3: false,
            uuid: '',
            rememberMe: true,
            fieldRules: {
                userName: [{ validator: validateName, trigger: blur }],
                password: [{ validator: validatePwd, trigger: blur }],
                patchca: [{ validator: validateCode, trigger: blur }]
            }
        }
    },
    methods: {
        judgeAdmin() {
            var host = window.location.host
            var lpsHost = 'www.lpswish.com'
            var lpsHost2 = 'www.lpswish.cn'
            var lpsHost3 = 'www.liuxueart.com'
            this.ifLps = host === lpsHost
            this.ifLps2 = host === lpsHost2
            this.ifLps3 = host === lpsHost3
            if (this.ifLps3) {
                document.title = '艺考留学在线'
                return
            }
            if (this.ifLps2) {
                document.title = '绿皮书生涯规划'
                return
            }
            if (this.ifLps) {
                document.title = '艺考要轻松'
            } else {
                document.title = '轻松艺考网'
            }
        },
        refreshPatchca: function() {
            this.uuid = this.global.uuid()
            const env = process.env.ENV
            let app = 'admin'
            env === 'dev' ? (app = `test${app}`) : ''
            var baseUri = process.env.HOST.replace('${application}', app)
            this.loginForm.src = baseUri + '/api/admin/patchca/' + this.uuid
        },
        login: function(formName) {
            this.loading = true
            const userInfo = {
                userName: this.loginForm.userName,
                password: this.loginForm.password,
                uuid: this.uuid,
                patchca: this.loginForm.patchca,
                rememberMe: this.rememberMe
            }
            this.$refs[formName].validate(valid => {
                if (!valid) {
                    this.loading = false
                    return false
                }
                this.$api.login
                    .login(userInfo)
                    .then(res => {
                        if (!res.success) {
                            this.$message({
                                message: res.message,
                                type: 'error'
                            })
                            this.refreshPatchca()
                            this.loading = false
                            return
                        }
                        if (!res.data['token']) {
                            this.$message({
                                message: '登录失败',
                                type: 'error'
                            })
                            this.refreshPatchca()
                            this.loading = false
                            return
                        }
                        sessionStorage.setItem(
                            'user',
                            JSON.stringify(res.data)
                        )
                        sessionStorage.setItem(
                            'access-token',
                            res.data['token']
                        )
                        // this.getPartners()
                        this.loading = false
                        this.$router.push(this.global.homeUrl)
                        // 保存用户信息
                        // 登录成功，跳转到主页
                    })
                    .then(() => {})
                    .catch(res => {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                        this.loading = false
                    })
            })
        },
        handleRegister() {
            this.$router.push('/register')
        }
    },
    mounted() {
        this.judgeAdmin()
        this.refreshPatchca()
    }
}
</script>

<style>
*,
:after,
:before {
    box-sizing: border-box;
}
.particles {
    background: radial-gradient(circle, #5690d2, #c6e2ff);
    /* height: calc(100vh - 4px); */
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.login {
    position: relative;
    -ms-flex-align: center;
    -webkit-box-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 100%;
    width: 100%;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 0 auto;
    width: 400px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    z-index: 999;
}
.title {
    margin: 0px auto 30px auto;
    text-align: center;
    color: #505458;
}

.remember {
    margin: 0px 0px 35px 0px;
}

.pointer {
    width: 130px;
    height: 40px;
    cursor: pointer;
}
.login-footer {
    z-index: 999;
    position: absolute;
    bottom: 50px;
    left: 32%;
}
.login-footer a {
    text-decoration: none;
}
.login-logo {
    z-index: 999;
    position: absolute;
    top: 50px;
    left: 50px;
}
.login-logo img {
    width: 200px;
}
.operation {

}
.operation .el-form-item__content {
    line-height: 20px;
    height: 30px;
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Index.vue